<template>
    <input
        type="number"
        class="rounded"
        :min="minQuantity"
        :max="maxQuantity"
        :value="modelValue"
        :step="step"
        :overrideMax="overrideMax"
        @change="handleChange"
        @input="handleInput"
        @keydown="handleKeydown"
        @focus="$event.target.select()"
        v-numbers
    />
</template>

<script>
    import { usePage } from '@inertiajs/inertia-vue3'
    import UseUserAuth from '@/Composables/UseUserAuth';

    export default {
        props: ['modelValue', 'step', 'min', 'max', 'overrideMax', 'lazy'],

        setup () {
            const { isAdmin } = UseUserAuth(usePage().props.value.user);

            return { isAdmin };
        },

        emits: ['update:modelValue', 'stockWarning'],

        computed: {
            minQuantity () {
                let defaultMin = this.isAdmin ? -9999 : 0;
                let minIsValid = this.min !== null && this.min !== '' && this.min !== undefined;

                return minIsValid ? this.min : defaultMin;
            },

            maxQuantity () {
                let maxIsValid = this.max !== null && this.max !== '' && this.max !== undefined;

                return (!this.overrideMax && maxIsValid) ? this.max : 9999;
            }
        },

        methods: {
            handleChange (event) {
                if (this.lazy === true) {
                    this.updateValue(event);
                }
            },

            handleInput (event) {
                if (this.lazy !== true) {
                    this.updateValue(event);
                }
            },

            handleKeydown (event) {
                // Force up/down arrows to increment/decrement by 1 instead of the input step value
                if(event.keyCode === 38) {
                    event.preventDefault();
                    event.target.value ++;
                    this.updateValue(event);
                }
                else if(event.keyCode === 40) {
                    event.preventDefault();
                    event.target.value --;
                    this.updateValue(event);
                }
            },

            updateValue (event) {
                if (event.target.value < this.minQuantity) event.target.value = this.minQuantity;
                else if (event.target.value > this.maxQuantity)
                {
                    this.$emit('stockWarning', event.target.value);
                    event.target.value = this.maxQuantity;
                }

                if (event.target.value !== '' && event.target.value % 1 !== 0) {
                    if(this.step == 0.25) event.target.value = Math.round(event.target.value * 4) / 4;
                    else if(this.step == 0.5) event.target.value = Math.round(event.target.value * 2) / 2;
                    else if (!this.step || this.step == 1) event.target.value = Math.round(event.target.value);
                }

                this.$emit('update:modelValue', event.target.value);
            }
        },
    }
</script>

